import CommunicationLayout from "./CommunicationLayout";
import { noticeRoutes } from "./modules/notices/routes";
import { popupBannerRoutes } from "./modules/popupBanner/routes";
import { featureIntroductionRoutes } from "./modules/featureIntroduction/routes"

export const communicationRoutes = {
  path: "communications",
  component: CommunicationLayout,
  children: [...noticeRoutes(), ...popupBannerRoutes(), ...featureIntroductionRoutes()]
};



// WEBPACK FOOTER //
// ./src/features/communications/routes.js